import * as R from 'ramda';
import { $set } from 'plow-js';
import { combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';
// common
import { ACTION_TYPE_CLEAN_FORM_REDUCER } from './common/actions';
// components
import modal from './components/modal/reducer';
import loader from './components/loader/reducer';
import orderTable from './common/idb/order/reducer';
import audio from './components/audio-player/reducer';
import resizeTable from './common/idb/resize/reducer';
// features
import auth from './features/auth/reducer';
import user from './features/user/reducer';
import intl from './features/intl/reducer';
import roles from './features/role/reducer';
import icons from './features/icons/reducer';
import newDO from './features/new-do/reducer';
import audit2 from './features/audit2/reducer';
import analytics from './features/analytics/reducer';
import quotes from './features/quotes/reducer';
import branch from './features/branch/reducer';
import locale from './features/locale/reducer';
import styling from './features/styling/reducer';
import carrier from './features/carrier/reducer';
import payrolls from './features/payroll/reducer';
import imports from './features/new-import/reducer';
import rateShop from './features/rate-shop/reducer';
import fleetMap from './features/fleet-map/reducer';
import sequences from './features/sequence/reducer';
import cloItems from './features/clo-items/reducer';
import reference from './features/reference/reducer';
import publicCLO from './features/public-clo/reducer';
import fuelCards from './features/fuel-cards/reducer';
import fleetList from './features/fleet-list/reducer';
import userSettings from './features/profile/reducer';
import loadBoard from './features/load-board/reducer';
import workOrder from './features/work-order/reducer';
import liteNewDO from './features/lite-new-do/reducer';
import reports from './features/report-format/reducer';
import config from './features/configurations/reducer';
import dashboards from './features/dashboards/reducer';
import pivotTable from './features/pivot-table/reducer';
import carrierEdi from './features/carrier-edi/reducer';
import appRelease from './features/app-release/reducer';
import permissions from './features/permission/reducer';
import iftaReport from './features/ifta-report/reducer';
import navbarMenu from './features/navbar-menu/reducer';
import newDOQuote from './features/new-do-quote/reducer';
import inspections from './features/inspections/reducer';
import driversCard from './features/drivers-card/reduces';
import mailSending from './features/mail-sending/reducer';
import tollCharges from './features/toll-charges/reducer';
import masterAudit from './features/master-audit/reducer';
import chargeReport from './features/charge-report/reducer';
import importReport from './features/import-report/reducer';
import notifications from './features/notification/reducer';
import dispatchGroup from './features/dispatch-group/reducer';
import carrierPortal from './features/carrier-portal/reducer';
import serviceVendor from './features/service-vendor/reducer';
import dispatchBoard from './features/dispatch-board/reducer';
import driverCardsV2 from './features/driver-cards-v2/reducer';
import vendorInvoices from './features/invoice/vendor/reducer';
import ediIntegration from './features/edi-integration/reducer';
import customerPortal from './features/customer-portal/reducer';
import templateReport from './features/template/report/reducer';
import carrierInvoice from './features/invoice/carrier/reducer';
import fleetDocuments from './features/fleet-documents/reducer';
import taskManagement from './features/task-management/reducer';
import loadReport from './features/dispatch-report/load/reducer';
import claimManagement from './features/claim-management/reducer';
import componentsStory from './features/components-story/reducer';
import losSubscription from './features/los-subscription/reducer';
import availableDriver from './features/available-driver/reducer';
import customerInvoice from './features/invoice/customer/reducer';
import trailerActivity from './features/trailer-activity/reducer';
import routeReport from './features/dispatch-report/route/reducer';
import orderReport from './features/dispatch-report/order/reducer';
import loadDetails from './features/dispatch-details/load/reducer';
import carrierContracts from './features/contracts/carrier/reducer';
import averageFuelPrice from './features/average-fuel-price/reducer';
import orderDetails from './features/dispatch-details/order/reducer';
import compensationGroup from './features/compensation-group/reducer';
import carrierInsurances from './features/carrier/insurances/reducer';
import dashboardsPayroll from './features/dashboards-payroll/reducer';
import expandedContainer from './features/expanded-container/reducer';
import customerContracts from './features/contracts/customer/reducer';
import customerMasterInvoice from './features/master-invoice/reducer';
import driverPayrollInvoices from './features/invoice/driver/reducer';
import dispatchBoardTel from './features/dispatch-board/load/reducer';
import dispatchPlannerV2 from './features/dispatch-planner-v2/reducer';
import vendorPayrolls from './features/payroll/vendor-payroll/reducer';
import dispatchBoardClo from './features/dispatch-board/order/reducer';
import containerTypes from './features/template/container-type/reducer';
import templateInspection from './features/template/inspection/reducer';
import geoFencingLocation from './features/geo-fencing-location/reducer';
import fleetProfileSimple from './features/fleet-profile-simple/reducer';
import centralizedDispatch from './features/centralized-dispatch/reducer';
import loadPlannerTemplate from './features/load-planner-template/reducer';
import normalizeCurrency from './features/normalize-currency-list/reducer';
import carrierRatingReport from './features/carrier-rating-report/reducer';
import commissionAssignment from './features/commission-assignment/reducer';
import telEvents from './features/dispatch-report/load/load-events/reducer';
import serviceVendorInvoice from './features/invoice/service-vendor/reducer';
import telByClo from './features/dispatch-report/load/load-by-order/reducer';
import cloByTel from './features/dispatch-report/order/order-by-load/reducer';
import ratingGeoFencingZone from './features/geo-fencing-zone/rating/reducer';
import reportGeoFencingZone from './features/geo-fencing-zone/report/reducer';
import carrierRateRequest from './features/carrier-rate-request-report/reducer';
import routeMassCreateReport from './features/route-mass-create-report/reducer';
import routeByLoad from './features/dispatch-report/route/route-by-load/reducer';
import dispatchPlannerEventsV2 from './features/dispatch-planner-events-v2/reducer';
import carrierStatisticReport from './features/carrier-statistic-report/reducer';
import equipmentServiceInvoice from './features/equipment-service-invoice/reducer';
// forms
import templates from './forms/forms/template-search/reducer';
// fleet-profile
import fleetProfile from './features/fleet-profile/reducer';
// carrier-profile
import carrierProfile from './features/carrier-profile/reducer';
// helpers/constants
import global from './common/reducer';
//////////////////////////////////////////////////

const appReducer = combineReducers({
  auth,
  intl,
  user,
  icons,
  newDO,
  audio,
  roles,
  audit2,
  analytics,
  modal,
  branch,
  toastr,
  global,
  loader,
  config,
  locale,
  quotes,
  styling,
  carrier,
  reports,
  imports,
  telByClo,
  cloByTel,
  payrolls,
  rateShop,
  fleetMap,
  cloItems,
  telEvents,
  liteNewDO,
  publicCLO,
  reference,
  fuelCards,
  templates,
  sequences,
  loadBoard,
  fleetList,
  workOrder,
  dashboards,
  navbarMenu,
  carrierEdi,
  newDOQuote,
  appRelease,
  loadReport,
  pivotTable,
  iftaReport,
  orderTable,
  resizeTable,
  routeReport,
  tollCharges,
  mailSending,
  orderReport,
  loadDetails,
  permissions,
  driversCard,
  routeByLoad,
  inspections,
  masterAudit,
  chargeReport,
  importReport,
  orderDetails,
  userSettings,
  carrierPortal,
  notifications,
  dispatchBoard,
  dispatchGroup,
  centralizedDispatch,
  serviceVendor,
  driverCardsV2,
  carrierProfile,
  taskManagement,
  containerTypes,
  customerPortal,
  carrierInvoice,
  vendorInvoices,
  ediIntegration,
  vendorPayrolls,
  templateReport,
  availableDriver,
  customerInvoice,
  dispatchPlannerV2,
  claimManagement,
  losSubscription,
  componentsStory,
  trailerActivity,
  averageFuelPrice,
  dispatchBoardTel,
  dispatchBoardClo,
  carrierContracts,
  carrierInsurances,
  customerContracts,
  dashboardsPayroll,
  compensationGroup,
  fleetDocuments,
  expandedContainer,
  normalizeCurrency,
  carrierRateRequest,
  geoFencingLocation,
  templateInspection,
  fleetProfileSimple,
  loadPlannerTemplate,
  carrierRatingReport,
  commissionAssignment,
  serviceVendorInvoice,
  ratingGeoFencingZone,
  reportGeoFencingZone,
  customerMasterInvoice,
  driverPayrollInvoices,
  dispatchPlannerEventsV2,
  routeMassCreateReport,
  carrierStatisticReport,
  equipmentServiceInvoice,
  // fleet-profile
  fleetProfile,
});

const rootReducer = (state, action) => {
  if (R.equals(action.type, ACTION_TYPE_CLEAN_FORM_REDUCER)) {
    const newState = $set('form', {}, state);

    return appReducer(newState, action);
  }

  return appReducer(state, action);
};

export default rootReducer;

export { appReducer };
